var React = require('react');

function Back (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"back-a","d":"M14 6.579V8.42H3.357l4.871 5.263L7 15 0 7.5 7 0l1.228 1.316-4.871 5.263z"})),React.createElement("use",{"fill":"currentColor","xlinkHref":"#back-a","key":1})]);
}

Back.defaultProps = {"viewBox":"0 0 14 15","width":"14","height":"15"};

module.exports = Back;

Back.default = Back;
